module.exports = __webpack_public_path__ + "img/zhineng_zuotu.4f27e816.png";